import { Component, OnInit } from '@angular/core';
import { PermissionsService } from '@app/modules/auth';
import { User, UserProfile } from '@app/modules/auth/models/core-user-api.model';
import { VdoUser } from '@app/modules/auth/models/vdo-user';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  user$: Subject<VdoUser> = new Subject<VdoUser>();
  userProfile$: Subject<UserProfile[]> = new Subject<UserProfile[]>();
  constructor(private permissions: PermissionsService) {}

  ngOnInit(): void {
    this.permissions.users$.pipe(first(users => Boolean(users.length))).subscribe(users => {
      this.user$.next(users[0]);
    });
    this.permissions.userProfiles$.pipe(first(profiles => Boolean(profiles.length))).subscribe(profiles => {
      this.userProfile$.next(profiles);
    });
  }
}
